module.exports = __webpack_public_path__ + "img/5.1ee8b5e5.png";